export default {"src":"/_next/static/media/GetInTouch.9b6cea0c.svg","height":1089,"width":1440,"blurWidth":0,"blurHeight":0};